import React, { PropTypes } from 'react';

const Resource = ({ src, alt = '' }) => (
  <div className="resource">
    <div className="asset">
      <div className="asset-image-wrapper">
        <img src={src} alt={alt} />
      </div>
    </div>
  </div>
);

Resource.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string
};

export default Resource;



// WEBPACK FOOTER //
// ./src/pages/press/components/Resource/Resource.js